import { render, staticRenderFns } from "./RegistraArtRes.vue?vue&type=template&id=1d6a3b77&scoped=true&"
import script from "./RegistraArtRes.vue?vue&type=script&lang=js&"
export * from "./RegistraArtRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6a3b77",
  null
  
)

export default component.exports